import { Icon, IconType } from '@lmc/ui-kit'
import styled from 'styled-components'
import colors from '@lmc/common/constants'
import { FC } from 'react'

export const Logo: FC = () => {
  return (
    <LogoWrapper>
      <StyledIconLogo customIcon={IconType.NewLogo} />
      <StyledIconLogoText customIcon={IconType.NewLogoText} />
    </LogoWrapper>
  )
}

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledIconLogo = styled(Icon)`
  height: 42px;
  width: 42px;
`

const StyledIconLogoText = styled(Icon)`
  height: 29px;
  width: 175px;
  fill: ${colors.darkpurple};
`
